import { types } from "mobx-state-tree";

import { MenuItems } from "../../components/secondary-menu/SecondaryMenu";
import {
  ManageSubscriptions,
  ViewSubscriptionUsage,
} from "../../services/authorization/Permissions";
import { permissionsService } from "../../services/authorization/UserPermissionsService";
import { currentUserService } from "../../services/user/CurrentUserStorage";

export const SubscriptionMenuItemsModel = types
  .model({})
  .actions((self) => {
    return {
      getStaticMenuItems(): MenuItems {
        return {
          "general.general": {
            items: [
              {
                id: "secondary-menu-usage",
                labelKey: "general.subscription-usage",
                path: "/usage",
                canAccess: permissionsService.userHasPermissionTo(ViewSubscriptionUsage),
              },
              {
                id: "secondary-menu-plans",
                labelKey: "general.subscription-plans",
                path: "/plans",
                canAccess: permissionsService.userHasPermissionTo(ManageSubscriptions),
              },
              {
                id: "secondary-menu-billing",
                labelKey: "general.subscription-billing",
                path: "/billing",
                canAccess: permissionsService.userHasPermissionTo(ManageSubscriptions) && currentUserService.currentUser.currentOrganization.hasPaidSubscription,
              },
            ],
            defaultOpen: true,
          },
        };
      },
    };
  });
